/**
 * Проверяет, относятся ли две метки времени к одному локальному календарному дню
 * (по часовому поясу машины пользователя). Используется для суточной чистки
 * истории уведомлений: запись «сегодня» — если её день совпадает с текущим.
 *
 * @param a - первая метка времени, ms
 * @param b - вторая метка времени, ms
 * @returns `true`, если обе метки приходятся на один и тот же локальный день
 */
export const isSameLocalDay = (a: number, b: number): boolean => {
  const dateA = new Date(a);
  const dateB = new Date(b);

  return (
    dateA.getFullYear() === dateB.getFullYear() &&
    dateA.getMonth() === dateB.getMonth() &&
    dateA.getDate() === dateB.getDate()
  );
};
